<script lang="ts">
    import { onChange } from "../../components/formComponents/helper"
    import Input from "../../components/formComponents/Input.svelte"

    export let field: TaskStepField<"text">,
        fullPath: string,
        value = ""
</script>

<div class="textWidget">
    <Input
        placeholder="{field.label}"
        id="{fullPath}{field.name}"
        type="text"
        onChange="{onChange}"
        bind:value="{value}"
    />
</div>

<style lang="less">
    .textWidget:global {
        width: 100%;
    }
</style>
